const IDENTITY_REQUIRED_EVENT = "zentjes:identity-required"

export function dispatchIdentityRequired(): void {
    if (typeof window === "undefined") return
    window.dispatchEvent(new CustomEvent(IDENTITY_REQUIRED_EVENT))
}

export function onIdentityRequired(callback: () => void): () => void {
    if (typeof window === "undefined") return () => { }
    const handler = () => callback()
    window.addEventListener(IDENTITY_REQUIRED_EVENT, handler)
    return () => window.removeEventListener(IDENTITY_REQUIRED_EVENT, handler)
}

export function clearZeroSession(): void {
    if (typeof window === "undefined") return
    localStorage.removeItem("zentjes-visitor-id")
    document.cookie = "zentjes-visitor-id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/"
}
